import { createContext } from 'react';
export const VirtualSlotsPlaceholderContext = createContext(undefined);
export const VirtualSlotsPlaceholderHighlightContext = createContext({});
export const VirtualSlotsPlaceholderHostId = createContext('');
export const RepeatedVirtualSlotsPlaceholderContext = createContext(undefined);
//# sourceMappingURL=slotsPlaceholderContext.js.map